import { useQuery } from '@tanstack/react-query'
import { 
  desaPublicApi, 
  pemerintahDesaPublicApi,
  type Desa,
  type StrukturPemerintahan,
  type StrukturPemerintahanResponse,
  type DesaInfo
} from '../../../shared-lib'

// Hooks for Desa Public API
export const useDesaDetail = () => {
  return useQuery({
    queryKey: ['desa', 'detail'],
    queryFn: async () => {
      const response = await desaPublicApi.getDesaDetail()
      return response.data
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
  })
}

export const useStrukturPemerintahan = () => {
  return useQuery({
    queryKey: ['pemerintahdesa', 'struktur','details'],
    queryFn: async () => {
      const response = await pemerintahDesaPublicApi.getStrukturPemerintahan()
      return response.data
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
  })
}